<template>
    <!-- <div>
        <DefaultVacationDaysForm
            :is-fetching-users="isFetchingUsers"
            :users-list="usersList"
            :is-fetching-departments="isFetchingDepartments"
            :departments-list="departmentsList"
            standalone
        />
        <hr class="my-10">
    </div> -->
    <v-row class="ma-0 ga-6 justify-space-between">
        <!-- Legacy per-year filter. Default vacation days are now user-level data.
        <v-col cols="12" md="4" class="px-0 flex-1-1-0">
            <v-autocomplete
                v-model="filters.years"
                label="Ano(s)"
                multiple
                :disabled="isFetchingDefaultDaysList"
                :loading="isFetchingDefaultDaysList"
                :items="yearsList"
                variant="outlined"
                clearable
            ></v-autocomplete>
        </v-col>
        -->
        <v-col cols="12" md="6" class="px-0 flex-1-1-0">
            <v-autocomplete
                v-model="filters.department_ids"
                label="Colaboradores do(s) Centro(s) de Custo"
                :disabled="isFetchingDepartments || isFetchingDefaultDaysList  || updatingDefaultVacationDaysUserIds?.length > 0"
                :loading="isFetchingDepartments"
                :items="departmentsList"
                multiple
                clearable
                autocomplete="off"
                variant="outlined"
                item-value="id"
                :item-title="(item) => `${item?.external_key || 'Sem código'} - ${item?.name || 'Sem nome'}`"
            >
                <template #selection="{ index }">
                    <span v-if="index === 0" class="text-truncate">
                        {{ filters.department_ids.length }}
                        Centro{{ filters.department_ids.length > 1 ? "s" : "" }}
                        selecionado{{ filters.department_ids.length > 1 ? "s" : "" }}
                    </span>
                </template>
            </v-autocomplete>
        </v-col>
        <v-col cols="12" md="6" class="px-0 flex-1-1-0">
            <v-autocomplete 
                v-model="filters.user_ids" 
                multiple
                clearable
                autocomplete="off" 
                label="Colaborador(a)" 
                variant="outlined" 
                
                :items="usersList"
                item-value="id" 
                :item-title="(item) => `${item?.worker_code || 'Sem código'} - ${item?.name || 'Sem Nome'}`"
                :disabled="isFetchingUsers || isFetchingDefaultDaysList  || updatingDefaultVacationDaysUserIds?.length > 0"
                :loading="isFetchingUsers"
            >
                <template #selection="{ index }">
                    <span v-if="index === 0" class="text-truncate">
                        {{ filters.user_ids.length }}
                        Colaborador{{ filters.user_ids.length > 1 ? "es" : "(a)" }}
                        selecionado{{ filters.user_ids.length > 1 ? "s" : "(a)" }}
                    </span>
                </template>
            </v-autocomplete>
        </v-col>
    </v-row>
    <v-row class="ma-0 ga-6 justify-space-between">
        <!-- <v-col cols="12" md="8" class="px-0">
            <v-range-slider 
                v-model="filters.default_days" 
                :min="minimumNumberOfDays" 
                :max="maximumNumberOfDays" 
                :strict="true" 
                :hide-details="true"
                :step="1"
                label="Dias de férias"
                :disabled="isFetchingDefaultDaysList  || updatingDefaultVacationDaysUserIds?.length > 0"
            >
                <template #prepend>
                    <v-text-field
                        v-model="filters.default_days[0]"
                        density="compact"
                        style="width: 70px"
                        type="number"
                        variant="outlined"
                        hide-details
                        single-line
                        :min="minimumNumberOfDays"
                        :max="filters.default_days[1]"
                    ></v-text-field>
                </template>
                <template #append>
                    <v-text-field
                        v-model="filters.default_days[1]"
                        density="compact"
                        style="width: 70px"
                        type="number"
                        variant="outlined"
                        hide-details
                        single-line
                        :min="filters.default_days[0]"
                        :max="maximumNumberOfDays"
                    ></v-text-field>
                </template>
            </v-range-slider>
        </v-col> -->
        <v-col class="px-0 flex-1-1-0 d-flex justify-end" cols="12" >
            <v-btn 
                class="text-none" 
                :prepend-icon="isFetchingDefaultDaysList ? 'mdi-loading mdi-spin' : 'mdi-filter'"
                color="primary" 
                variant="flat"
                :disabled="isFetchingDefaultDaysList || updatingDefaultVacationDaysUserIds?.length > 0"
                @click="fetchDefaultDays"
            >{{ isFetchingDefaultDaysList ? 'Atualizando Lista...' :'Filtrar' }}</v-btn>
        </v-col>
    </v-row>
    <v-data-table-server
        v-model:page="filters.page"
        v-model:items-per-page="filters.per_page"
        :sort-by="[{ key: filters.order_by, order: filters.direction }]"
        :items-length="filters.total"
        :items="defaultDaysList"
        :headers="defaultDaysTableHeaders"
        item-value="id"
        :loading="isFetchingDefaultDaysList"
        :loading-text="'Obtendo lista de dias de férias por Colaborador(a)'"
        @update:sort-by="handleSortByUpdate"
        hover
        :mobile="mdAndDown"
        :hide-default-footer="true"

    >
        <template #item.default_vacation_days="{ item }">
            <div class="d-flex justify-end">
                <v-text-field
                    v-model.number="item.default_vacation_days"
                    :disabled="isUpdatingDefaultVacationDays(item.id)"
                    :loading="isUpdatingDefaultVacationDays(item.id)"
                    density="compact"
                    hide-details
                    min="1"
                    type="number"
                    variant="outlined"
                    style="max-width: 96px"
                    @blur="updateDefaultVacationDays(item)"
                />
            </div>
        </template>
    </v-data-table-server>
    <div class="d-flex justify-end align-center">
        <strong v-if="/* !firstLoad */true">
            {{ filters.from ?? 1 }}
            -
            {{ filters.to ?? filters.per_page ?? 25 }}
            /
            {{ filters.total ?? "25" }}
        </strong>

        <v-pagination
            v-model="filters.page"
            :length="filters.last_page ?? 1"
            :total-visible="0"
            @update:model-value="fetchDefaultDays"
        />
    </div>
</template>
<script setup>
import { onMounted, ref } from 'vue';
import { getDate } from '../../../composables/datetime';
import Department from "../../../api/departments/Department";
import AbsenceRequest from '../../../api/absences/requests/AbsenceRequests';
import { useDisplay } from 'vuetify';
import DefaultVacationDaysForm from '../../../components/absences/requests/DefaultVacationDaysForm.vue';
import ManageAbsences from '../../../api/absences/requests/management/ManageAbsences.js';


const props = defineProps({
    
});
// Legacy per-year filter configuration. Default vacation days are now user-level data.
// const today = new Date();
// const currentYear = today.getFullYear();
const defaultDaysTableHeaders = [
    {
        title: "Colaborador(a)",
        key: "name",
        sortable: true,
        align: "start",
        value: (item) => `${item?.worker_code || "Sem código"} - ${item?.name || "Sem Nome"}`,
    },
    {
        title: "Centro de Custo",
        key: "paid_by_department",
        sortable: false,
        align: "start",
        value: (item) => `${item?.paid_by_department?.external_key || "Sem código"} - ${item?.paid_by_department?.name || "Sem Nome"}`,
    },
    // Legacy per-year column. Default vacation days are now user-level data.
    // {
    //     title: "Ano",
    //     key: "year",
    //     sortable: true,
    //     align: "center",
    // },
    {
        title: "Dias de férias",
        key: "default_vacation_days",
        sortable: true,
        align: "end",
    },
    // Legacy per-year column. Editing now happens inline in default_vacation_days.
    // {
    //     title: "Acções",
    //     key: "actions",
    //     sortable: false,
    //     align: "end",
    // },
];
const {mdAndDown} = useDisplay();

// Legacy per-year filter configuration. Default vacation days are now user-level data.
// const yearsList =
//     Array
//     .from(Array(currentYear + 2).keys())
//     .toReversed()
//     .toSpliced(currentYear - 2000)
//     ;

const departmentsList = ref([]);
const isFetchingDepartments = ref(false);
const usersList = ref([]);
const isFetchingUsers = ref(false);
const isFetchingDefaultDaysList = ref(false);
const defaultDaysList = ref([]);
const persistedDefaultVacationDays = ref({});
const updatingDefaultVacationDaysUserIds = ref([]);

const minimumNumberOfDays = 22;
const maximumNumberOfDays = 45;

const filters = ref({
    department_ids: [],
    user_ids: [],
    // Legacy per-year filter. Default vacation days are now user-level data.
    // years: [],
    default_days : [
        minimumNumberOfDays,
        maximumNumberOfDays
    ],
    order_by: "name",
    direction: "asc",
    page: 1,
    per_page: 10,
    from: 1,
    to: 10,
    total: 0,
    last_page: 1,
});



async function fetchDepartments() {
    if(isFetchingDepartments.value) {
        return;
    }

    try {
        isFetchingDepartments.value = true;
        
        const departmentsResponse = await Department.all({scope_to_user: 0});

        departmentsList.value = departmentsResponse?.data ?? [];

    } catch (error) {
        console.error(
            "Erro a obter lista de Centros de Custo",
            error,
        );
    } finally {
        isFetchingDepartments.value = false;
    }
}

async function fetchUsers() {
    if(isFetchingUsers.value) {
        return;
    }

    try {
        isFetchingUsers.value = true;

        const usersResoponse = await ManageAbsences.listUsers();

        usersList.value = usersResoponse?.data?.data
                            ?? usersResoponse?.data
                            ?? []
                            ;

    } catch (error) {
        console.error(
            "Ocorreu um erro a obter a lista de colaboradores:",
            error,
        )
    } finally {
        isFetchingUsers.value = false;
    }
}

async function fetchDefaultDays() {
    if(isFetchingDefaultDaysList.value) {
        return;
    }

    try {
        isFetchingDefaultDaysList.value = true;

        // Legacy per-year endpoint. Default vacation days are now stored on the user.
        // const defaultDaysResponse = await ManageAbsences.listDefaultDaysByUser(filters.value);
        // defaultDaysList.value = defaultDaysResponse?.data?.data
        //                         ?? defaultDaysResponse?.data
        //                         ?? [];

        const usersResponse = await ManageAbsences.listUsers(filters.value);
        const usersResponseData = usersResponse?.data ?? {};

        defaultDaysList.value = usersResponseData?.data ?? [];

        persistedDefaultVacationDays.value = Object.fromEntries(
            defaultDaysList.value.map((user) => [
                user.id,
                user.default_vacation_days,
            ]),
        );

        filters.value = {
            ...filters.value,
            from: usersResponseData?.from ?? 0,
            to: usersResponseData?.to ?? 0,
            page: usersResponseData?.current_page ?? filters.value.page,
            last_page: usersResponseData?.last_page ?? 1,
            total: usersResponseData?.total ?? 0,
        };
    } catch (error) {
        console.error(
            "Ocorreu um erro a obter a lista de dias de férias:",
            error,
        )
    } finally {
        isFetchingDefaultDaysList.value = false;
    }
}

function handleSortByUpdate(sortBy) {
    const sort = sortBy?.[0];

    if (!sort?.key || !sort?.order) {
        return;
    }

    filters.value = {
        ...filters.value,
        order_by: sort.key,
        direction: sort.order,
        page: 1,
    };

    fetchDefaultDays();
}

function isUpdatingDefaultVacationDays(userId) {
    return updatingDefaultVacationDaysUserIds.value.includes(userId);
}

async function updateDefaultVacationDays(user) {
    const originalValue = persistedDefaultVacationDays.value[user.id];
    const defaultVacationDays = Number(user.default_vacation_days);

    if (!Number.isInteger(defaultVacationDays) || defaultVacationDays < 1) {
        user.default_vacation_days = originalValue;
        return;
    }

    if (defaultVacationDays === originalValue) {
        return;
    }

    updatingDefaultVacationDaysUserIds.value = [
        ...updatingDefaultVacationDaysUserIds.value,
        user.id,
    ];

    try {
        const response = await ManageAbsences.updateUserDefaultVacationDays(
            user.id,
            {
                default_vacation_days: defaultVacationDays,
            },
        );

        const savedValue = response?.data?.default_vacation_days
            ?? defaultVacationDays;

        user.default_vacation_days = savedValue;
        persistedDefaultVacationDays.value[user.id] = savedValue;
    } catch (error) {
        user.default_vacation_days = originalValue;

        console.error(
            "Ocorreu um erro ao atualizar os dias de férias padrão:",
            error,
        );
    } finally {
        updatingDefaultVacationDaysUserIds.value =
            updatingDefaultVacationDaysUserIds.value.filter(
                (userId) => userId !== user.id,
            );
    }
}

onMounted(() => {
    fetchDepartments();
    fetchDefaultDays();
    fetchUsers();
})

</script>
